export const BODY_PART_LABELS: Record<string, string> = {
  head_left_front: "Lt. Head",
  head_left_back: "Lt. Head",
  head_right_front: "Rt. Head",
  head_right_back: "Rt. Head",
  neck_front: "Neck",
  neck_back: "Neck",
  left_chest_front: "Lt. Chest",
  right_chest_front: "Rt. Chest",
  left_abdomen_front: "Lt. Abdomen",
  right_abdomen_front: "Rt. Abdomen",
  left_shoulder_front: "Lt. Shoulder",
  left_shoulder_back: "Lt. Shoulder",
  right_shoulder_front: "Rt. Shoulder",
  right_shoulder_back: "Rt. Shoulder",
  left_upper_arm_front: "Lt. Upper Arm",
  left_upper_arm_back: "Lt. Upper Arm",
  right_upper_arm_front: "Rt. Upper Arm",
  right_upper_arm_back: "Rt. Upper Arm",
  left_forearm_front: "Lt. Forearm",
  left_forearm_back: "Lt. Forearm",
  right_forearm_front: "Rt. Forearm",
  right_forearm_back: "Rt. Forearm",
  left_hand_front: "Lt. Hand",
  left_hand_back: "Lt. Hand",
  right_hand_front: "Rt. Hand",
  right_hand_back: "Rt. Hand",
  left_thigh_front: "Lt. Thigh",
  right_thigh_front: "Rt. Thigh",
  left_thigh_back: "Lt. Thigh",
  right_thigh_back: "Rt. Thigh",
  left_knee_front: "Lt. Knee",
  right_knee_front: "Rt. Knee",
  left_calf_back: "Lt. Calf",
  right_calf_back: "Rt. Calf",
  left_foot_front: "Lt. Foot",
  left_foot_back: "Lt. Foot",
  right_foot_front: "Rt. Foot",
  right_foot_back: "Rt. Foot",
  left_buttock_back: "Lt. Buttock",
  right_buttock_back: "Rt. Buttock",
  pelvis_front: "Pelvis",
  left_lower_back: "Lt. Lower Back",
  right_lower_back: "Rt. Lower Back",
  left_upper_back: "Lt. Upper Back",
  right_upper_back: "Rt. Upper Back",
};
